import {IPaylodAction} from '../interfaces/dispatchers'
import {IExportMap} from '../interfaces/reducers'
import ExportMapActions from '../enums/ActionTypes/ExportMapActions'
import {PageSize} from '../interfaces/models'

const initState: IExportMap = {
  exportJobs: {},
  landscape: false,
  pageSize: PageSize.A4,
  zoomFactor: 1,
  margins: [36, 36, 36, 36],
  dpi: 300,
  defaultLayoutWidth: 0,
  defaultLayoutHeight: 0,
  dpiFactor: 1,
  pixelsToUnitsFactor: 1,
  unitMmFactor: 297 / 842,
  previewMode: false,
  pixelsToMMFactor: 0,
  canvasWhMM: [0, 0],
  useBackground: false,
  mapProps: {
    scale: 1000,
    mapPaparWh: [0, 0],
    prefferedMapPixelWh: [0, 0],

    resizibleHeight: 600,
    resizibleWidth: 800,
    resizibleLeft: 100,
    resizibleTop: 200
  },
  layouts: {},
  elements: {
    legend: {
      resizibleHeight: 469,
      resizibleWidth: 990,
      resizibleLeft: 52,
      resizibleTop: 1110,
      type: 'legend'
    },
    scale: {
      resizibleHeight: 64,
      resizibleWidth: 311,
      resizibleLeft: 405,
      resizibleTop: 1044,
      type: 'scale'
    }
  }
}
initState.dpiFactor = initState.dpi / 150
let stateSnapShot = initState
const exportMap = (state: IExportMap = initState, action: IPaylodAction) => {
  switch (action.type) {
    case ExportMapActions.START_JOB:
      stateSnapShot = {...state, exportJobs: {...state.exportJobs, ...action.payload}}
      break
    case ExportMapActions.SET_LAYOUT_WH:
      stateSnapShot = {...state, defaultLayoutWidth: action.payload[0], defaultLayoutHeight: action.payload[1]}
      break
    case ExportMapActions.SET_MARGINS:
      stateSnapShot = {...state, margins: action.payload}
      break
    case ExportMapActions.SET_PREVIEW_MODE:
      stateSnapShot = {...state, previewMode: action.payload}
      break
    case ExportMapActions.SET_ELEMENT_PROPS:
      stateSnapShot = {...state, elements: {...action.payload}}
      break
    case ExportMapActions.SET_MAP_PROPS:
      stateSnapShot = {...state, mapProps: {...action.payload}}
      break
    case ExportMapActions.SET_ZOOM_FACTOR:
      stateSnapShot = {...state, zoomFactor: action.payload}
      break
    case ExportMapActions.SET_FEATURES:
      stateSnapShot = {...state, features: action.payload}
      break
    case ExportMapActions.SET_DPI:
      stateSnapShot = {...state, dpi: action.payload, dpiFactor: action.payload / 150}
      break
    case ExportMapActions.SET_LAYOUTS:
      stateSnapShot = {...state, layouts: action.payload}
      break
    case ExportMapActions.SET_NON_MARGIN_PAPER_WH_MM:
      stateSnapShot = {...state, canvasWhMM: action.payload}
      break
    case ExportMapActions.SET_PIXEL_TO_UNIT_FACTOR:
      stateSnapShot = {...state, pixelsToUnitsFactor: action.payload}
      break
    case ExportMapActions.SET_PIXEL_TO_MM_FACTOR:
      stateSnapShot = {...state, pixelsToMMFactor: action.payload}
      break
    case ExportMapActions.SET_LANDSCAPE:
      stateSnapShot = {...state, landscape: action.payload}
      break
    case ExportMapActions.SET_PAGE_SIZE:
      stateSnapShot = {...state, pageSize: action.payload}
      break
    case ExportMapActions.SET_USE_BACKGROUND:
      stateSnapShot = {...state, useBackground: action.payload}
      break
    default:
      stateSnapShot = state
      break
  }
  return stateSnapShot
}

;(window as any).gep = () => {
  return stateSnapShot
}

export default exportMap
